module.exports = __webpack_public_path__ + "static/img/payment.868d93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment.png
// module id = mMLd
// module chunks = 1